/**
 * 飞书错误上报 - 常量配置
 */

/** 默认的 API 错误关键词（这些错误不上报到飞书） */
export const DEFAULT_API_ERROR_KEYWORDS = [
  'request:fail',
  '网络请求失败',
  'fetch failed',
  'Failed to fetch',
  'Network Error',
  'NetworkError',
  'AbortError',
  'timeout',
];
